import { createSlice } from '@reduxjs/toolkit'
import { ReviewStatus } from 'features/Codes'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'

export const fetchChannels = createAxiosThunk(
  'creativeListFilter/fetchChannels',
  () => api.ad.getBizChannels()
)

const initialState = {
  isChannelsLoading: true,
  filterCreativeStatus: [
    { id: 'ON', name: '등록', checked: true },
    { id: 'DELETED', name: '삭제', checked: false },
  ],
  filterReviewStatus: [
    { ...ReviewStatus.APPROVED, checked: true },
    { ...ReviewStatus.APPROVING, checked: true },
    { ...ReviewStatus.REJECTED_APPROVAL, checked: true },
  ],
  filterBizChannels: [],
  checkedAllBizChannels: true,
}

const creativeListFilterSlice = createSlice({
  name: 'creativeListFilter',
  initialState,

  reducers: {
    resetFilters: () => initialState,
    checkCreativeStatus: (state, { payload: id }) => {
      const checkedStatus = state.filterCreativeStatus.find(
        status => status.id === id
      )
      if (
        checkedStatus.checked &&
        state.filterCreativeStatus.filter(status => status.checked).length > 1
      ) {
        checkedStatus.checked = !checkedStatus.checked
      } else if (!checkedStatus.checked) {
        checkedStatus.checked = true
      }
    },
    checkReviewStatus: (state, { payload: name }) => {
      const checkedStatus = state.filterReviewStatus.find(
        status => status.name === name
      )
      if (
        checkedStatus.checked &&
        state.filterReviewStatus.filter(status => status.checked).length > 1
      ) {
        checkedStatus.checked = !checkedStatus.checked
      } else if (!checkedStatus.checked) {
        checkedStatus.checked = true
      }
    },
    checkBizChannel: (state, { payload: { id, checked } }) => {
      const checkedChannel = state.filterBizChannels.find(
        channel => channel.id === id
      )
      checkedChannel.checked = checked
      if (checked) {
        state.checkedAllBizChannels = false
      } else if (
        state.filterBizChannels.filter(item => item.checked).length === 0
      ) {
        state.checkedAllBizChannels = true
      }
    },
    setCheckedAllBizChannels: state => {
      if (!state.checkedAllBizChannels) {
        state.checkedAllBizChannels = true
        state.filterBizChannels.forEach(channel => {
          channel.checked = false
        })
      }
    },
  },

  extraReducers: builder => {
    builder.addCase(fetchChannels.pending, state => {
      state.isChannelsLoading = true
    })

    builder.addCase(fetchChannels.fulfilled, (state, { payload }) => {
      state.filterBizChannels = payload.content.map(
        ({ id, name, siteUrl }) => ({
          id,
          name,
          siteUrl,
          checked: false,
        })
      )
      state.isChannelsLoading = false
    })

    builder.addCase(fetchChannels.rejected, (state, action) => {
      state.error = action.payload || true
      state.isChannelsLoading = false
    })
  },
})

export const {
  resetFilters,
  checkBizChannel,
  checkReviewStatus,
  checkCreativeStatus,
  setCheckedAllBizChannels,
} = creativeListFilterSlice.actions

export default creativeListFilterSlice.reducer
